// Meta Pixel + Conversions API, de-duplicated by event_id.
//
// Fires the Pixel with `{ eventID }` (production only, as before) and, when
// the page says the Conversions API is on for this visitor (the
// `laced-meta-capi` meta tag, rendered only with advertising-cookie consent),
// posts the same event to /api/v1/meta_events so it's also sent
// server-side. Meta counts the pair once.
//
// The inline helper in app/views/shared/_facebook_pixel.html.erb does the
// same for the server-rendered events.

import { envUtils } from '..'

export const META_CAPI_EVENTS = [
  'PageView',
  'ViewContent',
  'Search',
  'AddToCart',
  'InitiateCheckout',
  'AddPaymentInfo',
  'CompleteRegistration'
]

export type MetaCustomData = {
  content_ids?: string[]
  content_type?: 'product' | 'product_group'
  content_name?: string
  content_category?: string
  value?: number | string | null
  currency?: string
  search_string?: string
  num_items?: number
}

export const newMetaEventId = (): string => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID()
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const capiEnabled = () =>
  typeof document !== 'undefined' &&
  !!document.querySelector('meta[name="laced-meta-capi"]')

export const sendMetaServerEvent = (
  eventName: string,
  eventId: string,
  customData: MetaCustomData
) => {
  if (!META_CAPI_EVENTS.includes(eventName) || !capiEnabled()) return
  if (typeof window.fetch !== 'function') return

  window
    .fetch('/api/v1/meta_events', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_name: eventName,
        event_id: eventId,
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: window.location.href,
        action_source: 'website',
        custom_data: customData,
        consent: true
      })
    })
    .catch(() => {})
}

export const trackMetaEvent = (
  eventName: string,
  customData: MetaCustomData = {},
  eventId: string = newMetaEventId()
): string => {
  if (envUtils.isProduction() && window.fbq) {
    window.fbq('track', eventName, customData, { eventID: eventId })
  }

  sendMetaServerEvent(eventName, eventId, customData)

  return eventId
}
